<template>
  <div>
    <b-card v-for="(item,index) in cites" :key="index" :title="item.name"
            :sub-title="item.disc"
            class="col-md-10 offset-md-1 mt-4"
    >
      <b-table :fields="item.fields" :items="item.items" hover class="mt-4">
        <template slot="Website" slot-scope="item">
          <b-link :href="item.value">{{item.value}}</b-link>
        </template>
      </b-table>
      <div class="mt-5">
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'SoftWare',
  data: function () {
    return {
      cites: [
        {
          name: 'Data Analysis',
          disc: 'The software used in the process of data analysis',
          fields: ['Name', 'Version', 'Website'],
          items: [
            {Name: 'python', Version: 3.6, Website: 'https://www.python.org/'},
            {Name: 'R', Version: '2.5.2', Website: 'https://www.r-project.org/'},
            {Name: 'R Studio', Version: '3.0.1', Website: 'https://rstudio.com/'},
            {Name: 'DESeq2', Version: '3.6.0', Website: 'http://www.bioconductor.org/packages/release/bioc/html/DESeq2.html'},
            {Name: 'GISTIC2', Version: '0.18.0', Website: 'https://www.biostars.org/t/gistic2/'},
            {Name: 'R package Survival', Version: '1.1.1', Website: 'https://www.rdocumentation.org/packages/survival/versions/2.42-3'}
          ]
        },
        {
          name: 'Software',
          disc: 'The software used in this web interface',
          fields: ['Name', 'Version', 'Website'],
          items: [
            {Name: 'Apache HTTP Server', Version: 2.4, Website: 'https://www.apache.org/'},
            {Name: 'PHP', Version: 5.6, Website: 'http://php.net/'},
            {Name: 'MariaDB', Version: 5.7, Website: 'https://mariadb.org/'},
            {Name: 'Vue', Version: '2.5.2', Website: 'https://vuejs.org/index.html'},
            {Name: 'vue-router', Version: '3.0.1', Website: 'https://router.vuejs.org/'},
            {Name: 'webpack', Version: '3.6.0', Website: 'https://webpack.js.org/'},
            {Name: 'Axios', Version: '0.18.0', Website: 'https://github.com/axios/axios'},
            {Name: 'bootstrap-vue', Version: '2.0.0-rc.11', Website: 'https://bootstrap-vue.js.org/'},
            {Name: 'echarts', Version: '4.1.0', Website: 'http://echarts.baidu.com/'},
            {Name: 'echarts-stat', Version: '1.1.1', Website: 'http://echarts.baidu.com/'}
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SoftWare.vue